export default "__VITE_ASSET__CcS2Omnb__"